// @flow
import clsx from 'clsx';
import { Check, X } from 'lucide-react';

import { useTranslator } from '@gandi/translate';

import { Button, type ButtonProps } from '@gandi/ui';

import { useDelayedProps } from 'src/hooks/useDelayedProps';

import styles from './XsellButton.scss';

type Props = {
  SHSAdded: boolean,
  handleClick: () => Promise<void>,
  loading: boolean,
  visibility?: ButtonProps['visibility'],
  disabled?: boolean,
};

export function XsellButton({
  SHSAdded,
  handleClick,
  loading,
  visibility,
  disabled,
}: Props): React.MixedElement {
  const { __ } = useTranslator();

  const added = SHSAdded && !loading;
  const { label, Icon, intent } = useDelayedProps(
    { label: __('Added'), Icon: Check, intent: 'brand' },
    { label: __('Remove'), Icon: X, intent: 'default' },
    added,
  );

  const CurrentIcon = added ? Icon : undefined;
  const currentLabel = added ? label : __('Get the deal');

  return (
    <Button
      className={clsx(
        styles.root,
        intent === 'default' ? styles.default : undefined,
      )}
      type="button"
      onClick={handleClick}
      loading={loading}
      intent={SHSAdded ? intent : 'brand'}
      title={currentLabel}
      visibility={visibility}
      disabled={disabled}
    >
      {CurrentIcon && <CurrentIcon size={16} />}
      {currentLabel}
    </Button>
  );
}
